import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

/**
 * Publica el "nivel de detalle" de las migas de pan (ui-redesign).
 * Las pantallas de detalle (contrato, oportunidad, centro, persona) fijan aquí
 * el nombre de la entidad cargada para que app-breadcrumbs lo muestre como
 * último nivel (no navegable), un escalón más profundo que el listado.
 */
@Injectable({ providedIn: "root" })
export class BreadcrumbService {
	private readonly _detail$ = new BehaviorSubject<string | null>(null);
	readonly detail$ = this._detail$.asObservable();

	/** Fija el nombre de la entidad de detalle (o null para limpiar). */
	setDetail(label: string | null | undefined): void {
		this._detail$.next(label ? label.trim() : null);
	}

	/** Limpia el nivel de detalle (al salir de la pantalla). */
	clear(): void {
		this._detail$.next(null);
	}
}
